import { env } from "configs/EnvironmentConfig";
import fetchV2 from "auth/FetchInterceptorV2";

const resourceGlobalService = {};

resourceGlobalService.getPreview = ({ resourceId }) => {
  return fetchV2({
    url: `${env.API_MSP}/resource-global/preview/${resourceId}`,
    method: "get",
  });
};
resourceGlobalService.downloadMultipleResources = resourceIds => {
  return fetchV2({
    url: `${env.API_MSP}/resource-global/download-multiple-files`,
    method: "post",
    data: {
      ids: resourceIds,
    },
    responseType: "arraybuffer",
  });
};
resourceGlobalService.downloadResources = ({ id, name }) => {
  return fetchV2({
    url: `${env.API_MSP}/resource-global/preview/${id}`,
    method: "get",
  });
};
resourceGlobalService.deleteResource = id => {
  return fetchV2({
    url: `${env.API_MSP}/resource-global/${id}`,
    method: "delete",
  });
};

export default resourceGlobalService;
